module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAAAAADhgtq/AAABFElEQVQoz2P4jwswUF/maLi8iHnfDyDra5MGi6DXbphMHQMY6D39/0QDwqyEyCxiYCi7/2qtNYP5bzMGx52/3jYwMCwAyfyVYpgJ0v3WiCGYwfgdiDmbQeovUOYMgzHEyutiDGLXIUwDhnNAmU0MPlDXvFj9AsryYdgElDnCYIXhYmuGw0CZHwIMG9EkNjII/AC5rYtB8S6KxF1Fhi6wq/96MGggSz3SYPD4C/HpV0cGo0cICWMGx6+w0PlqzmAMk3pqzGD2ARGiH8wYrCAufmELlYCF9Qd9BluQ1CtbBp23qLHwSofB8f3/924MOq/Q4+eVBoMbUEL5BWbMPVZmcGdQfowtTh8rMUg/xh7bt81vU5hCALL9+1+ZI7RtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/images/icon-save.png
// module id = 645
// module chunks = 0